function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 13L5.72113 0H7.6948L13.4659 13H10.6678L9.1688 9.63752H4.32208L2.79811 13H0ZM5.24645 7.29326H8.16948L6.72046 3.36248L5.24645 7.29326Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.264 13V2.34426H13.7407V0H21.3606V2.34426H18.8123V13H16.264Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6597 13V0H26.1323L29.8048 9.94536L33.5273 0H36.975V13H34.4267V3.24408L30.8791 13H28.7306L25.183 3.24408V13H22.6597Z"
});

function SvgAtms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 13,
    viewBox: "0 0 37 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtms);
export default __webpack_public_path__ + "static/media/atms.a387a634.svg";
export { ForwardRef as ReactComponent };